import { FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material'
import { OrgUserRole } from 'api/model'
import { COLORS } from 'app-constants'

const RoleRadioGroup = ({
  role,
  onRoleChange,
  disabled,
  isDarkBackdrop = false,
}: {
  role?: OrgUserRole
  onRoleChange: (role: OrgUserRole) => void
  disabled: boolean
  isDarkBackdrop?: boolean
}) => {
  const onRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onRoleChange((event.target as HTMLInputElement).value as OrgUserRole)
  }

  return (
    <RadioGroup
      value={role}
      onChange={onRadioChange}
      sx={{
        '.MuiRadio-root': {
          marginRight: '8px',
        },
        '.MuiFormControlLabel-root': {
          alignItems: 'flex-start',
          ml: 0,
        },
      }}>
      <FormControlLabel
        disabled={disabled}
        value={OrgUserRole.admin}
        labelPlacement="end"
        control={
          <Radio sx={{ padding: 0, color: role === OrgUserRole.admin ? COLORS.JELLED_PRIMARY_BLUE : COLORS.GRAY_4 }} />
        }
        sx={{ mb: 3 }}
        label={
          <>
            <Typography
              variant="h5"
              sx={{
                color: COLORS.GRAY_1,
              }}>
              Administrator
            </Typography>
            <Typography
              variant="pS"
              sx={{
                color: COLORS.GRAY_0,
              }}>
              The user will have editing capability for all the features in the app
            </Typography>
          </>
        }
      />
      <FormControlLabel
        disabled={disabled}
        value={OrgUserRole.member}
        control={
          <Radio sx={{ padding: 0, color: role === OrgUserRole.member ? COLORS.JELLED_PRIMARY_BLUE : COLORS.GRAY_4 }} />
        }
        sx={{ mb: 3 }}
        label={
          <>
            <Typography
              variant="h5"
              sx={{
                color: COLORS.GRAY_1,
              }}>
              User
            </Typography>
            <Typography
              variant="pS"
              sx={{
                color: COLORS.GRAY_0,
              }}>
              The user will not have any editing capability for all the features in the app
            </Typography>
          </>
        }
      />
    </RadioGroup>
  )
}

export default RoleRadioGroup
